import * as types from './actionTypes';
import getAPIPath from '../../js/modules/api-location';
import handleErrors from './handleErrors';

export function loadContentListSuccess(res) {
  return { type: types.LOAD_CONTENT_LIST_SUCCESS, res };
}

export function loadMoreContentListSuccess(res) {
  return { type: types.LOAD_MORE_CONTENT_LIST_SUCCESS, res };
}

export function loadContentList(pageSize, cursor, loadMore) {
  let cursorParams = '';
  if (cursor) {
    cursorParams = `&cursor=${cursor}`;
  }

  return function(dispatch) {
    // If we are loading all the users content
    return fetch(`${getAPIPath}queryapi/user/listings?page_size=${pageSize}${cursorParams}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(handleErrors)
    .then(response => response.json().then((res) => {
      // We need to distinguish whether we are loading more content or loading new content
      // The resulting reducer will either replace the entire content object, or append new content to the end of current content list
      if (loadMore === true) {
        dispatch(loadMoreContentListSuccess(res));
      } else {
        dispatch(loadContentListSuccess(res));
      }
    }))
    .catch((error) => {
      throw (error);
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/contentListActions.js